<template>
  <div>
    <div ref="newBtn">
      <vs-button color="secondary" type="border" @click="movePage(0)" class="custom-btn">
        <div class="flex items-center justify-center gap-2">
          <feather-icon icon="ExternalLinkIcon" style="width: 20px; height: 20px" />
          <p>산업재해 발생현황</p>
        </div>
      </vs-button>
      <vs-button :class="postId ? 'block' : 'hidden'" color="secondary" type="border" @click="movePage(1)" class="custom-btn">
        <div class="flex items-center justify-center gap-2">
          <feather-icon icon="ExternalLinkIcon" style="width: 20px; height: 20px" />
          <p>위험성평가(개선후)</p>
        </div>
      </vs-button>
    </div>

    <p v-if="is위험도20" class="flex justify-end items-center" style="color: #ea5455">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.79995 5.8C9.79995 5.35817 9.44178 5 8.99995 5C8.55812 5 8.19995 5.35817 8.19995 5.8V9C8.19995 9.44183 8.55812 9.8 8.99995 9.8C9.44178 9.8 9.79995 9.44183 9.79995 9V5.8ZM8.99597 11.4C8.55634 11.4 8.19995 11.7582 8.19995 12.2C8.19995 12.6418 8.55634 13 8.99597 13H9.00393C9.44356 13 9.79995 12.6418 9.79995 12.2C9.79995 11.7582 9.44356 11.4 9.00393 11.4H8.99597Z"
          fill="#EA5455"
        />
      </svg>
      위험도 20점 이상 건이 있습니다. 담당임원에게 결재 바랍니다.
    </p>

    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :fieldReadonly="board.readonly || isRevision" :board="board" :is-print="isPrint" />

    <!-- 위험성평가 구분 -->
    <maot-section title="위험성평가 구분">
      <radio-group class="col-span-4" :items="['DKRAS', 'JSA']" :row-count="2" :readonly="board.readonly || isRevision" v-model="form.위험성평가구분" />
    </maot-section>

    <!-- 위험성평가 정보 -->
    <maot-section title="위험성평가 정보">
      <div class="col-span-12 writeGridContainer m-0">
        <div>
          <div>평가일자</div>
          <date-selector v-model="form.위험성평가정보.평가일자" :readonly="board.readonly || isRevision" />
        </div>
        <div class="writeGridCol2">
          <div>공정명</div>
          <div class="flex gap-2">
            <div class="flex items-center gap-2 whitespace-no-wrap" style="width: 108px"><ml-input v-model="form.위험성평가정보.팀" :readonly="board.readonly || isRevision" />팀</div>
            <div class="flex items-center gap-2 whitespace-no-wrap" style="width: 108px"><ml-input v-model="form.위험성평가정보.공장" :readonly="board.readonly || isRevision" />공장</div>
            <div class="flex items-center gap-2 whitespace-no-wrap" style="width: 108px"><ml-input v-model="form.위험성평가정보.공정" :readonly="board.readonly || isRevision" />공정</div>
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 공정분류 -->
    <maot-section title="공정분류">
      <template #right>
        <select736-button v-if="!(board.readonly || isRevision)" v-model="form.공정분류.raw" @input="onSelectProcess" />
      </template>
      <div class="col-span-12 writeGridContainer m-0">
        <div>
          <div>대분류</div>
          <ml-input v-model="form.공정분류.대분류" readonly />
        </div>
        <div>
          <div>중분류</div>
          <ml-input v-model="form.공정분류.중분류" readonly />
        </div>
        <div>
          <div>소분류</div>
          <ml-input v-model="form.공정분류.소분류" readonly />
        </div>
        <div>
          <div>구분</div>
          <div>
            <radio-group flex :items="['정기', '수시']" :readonly="board.readonly || isRevision" v-model="form.공정분류.구분">
              <template #수시>
                <custom-option-selector
                  class="flex-1"
                  style="width: 108px"
                  addable-option
                  :readonly="board.readonly || isRevision"
                  :isPrint="isPrint"
                  :options="['산재', '설비안전위원회', '투자', '설비 신설', '연료변경', '기타(직접입력)']"
                  v-model="form.공정분류.구분_수시"
                />
                <ml-input v-if="form.공정분류.구분_수시 === '기타(직접입력)'" v-model="form.공정분류.구분_수시_기타" :readonly="board.readonly || isRevision" />
              </template>
            </radio-group>
          </div>
        </div>

        <div>
          <div>아차사고</div>
          <div>
            <radio-group flex :readonly="board.readonly || isRevision" :items="['Y', 'N']" v-model="form.공정분류.아차사고" />
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 아차사고 -->
    <div v-if="form.공정분류.아차사고 === 'Y'">
      <table v-if="isPrint">
        <tr>
          <th colspan="2">재해/발생유형</th>
          <th>원인</th>
          <th>내용</th>
        </tr>
        <tr v-for="(row, rowIndex) in form.아차사고_개정" :key="`row${rowIndex}`">
          <td>{{ row.재해발생유형_분류 }}</td>
          <td>{{ row.재해발생유형_원인 }}</td>
          <td>{{ row.원인 }}</td>
          <td>{{ row.내용 }}</td>
        </tr>
      </table>
      <table-custom
        v-else
        class="table-custom mb-6 col-span-12"
        title="아차사고"
        border-x
        :board="board"
        :controls="!(board.readonly || isRevision)"
        :is-print="isPrint"
        :tableData="[
          { id: '재해발생유형', title: '재해/발생유형', type: 'customType', readonly: board.readonly || isRevision },
          { id: '원인', title: '원인', type: 'text', readonly: board.readonly || isRevision },
          { id: '내용', title: '내용', type: 'text', readonly: board.readonly || isRevision },
        ]"
        v-model="form.아차사고_개정"
      >
        <template #customType="{ id, index }">
          <div class="flex gap-2">
            <risk-fact-selector v-model="form.아차사고_개정[index].재해발생유형_분류" :readonly="board.readonly || isRevision" />
            <risk-fact-selector v-model="form.아차사고_개정[index].재해발생유형_원인" :분류="form.아차사고_개정[index].재해발생유형_분류" :readonly="board.readonly || isRevision" />
          </div>
        </template>
      </table-custom>
    </div>

    <!-- 작업빈도 -->
    <maot-section title="작업빈도(횟수)">
      <table class="col-span-12">
        <thead>
          <tr>
            <th>일</th>
            <th>주</th>
            <th>월</th>
            <th>분기</th>
            <th>년</th>
            <th>1회 작업시간(분)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><number-input v-model="form.작업빈도.일" :readonly="board.readonly || isRevision" /></td>
            <td><number-input v-model="form.작업빈도.주" :readonly="board.readonly || isRevision" /></td>
            <td><number-input v-model="form.작업빈도.월" :readonly="board.readonly || isRevision" /></td>
            <td><number-input v-model="form.작업빈도.분기" :readonly="board.readonly || isRevision" /></td>
            <td><number-input v-model="form.작업빈도.년" :readonly="board.readonly || isRevision" /></td>
            <td><number-input v-model="form.작업빈도.회당작업시간" :readonly="board.readonly || isRevision" /></td>
          </tr>
        </tbody>
      </table>
    </maot-section>

    <!-- 담당 -->
    <maot-section title="담당">
      <div class="col-span-12 writeGridContainer">
        <div>
          <div>작성자</div>
          <div>
            <div v-if="isPrint" class="print-input">{{ form.sign.작성자.name }}</div>
            <ml-input v-else v-model="form.sign.작성자.name" :readonly="board.readonly || isRevision" />
          </div>
        </div>
      </div>
      <div class="col-span-12 writeGridContainer">
        <div>
          <div>검토자</div>
          <div>
            <div v-if="isPrint" class="print-input">{{ form.sign.검토자.name }}</div>
            <ml-input v-else v-model="form.sign.검토자.name" :readonly="board.readonly || isRevision" />
          </div>
        </div>
      </div>
    </maot-section>

    <!-- 동일직무인원 -->
    <maot-section title="동일직무인원">
      <div class="col-span-12 writeGridContainer">
        <div>
          <div>상주반</div>
          <div class="grid items-center gap-2" style="grid-template-columns: 1fr auto"><number-input class="mr-2" v-model="form.동일직무인원.상주반" :readonly="board.readonly || isRevision" />명</div>
        </div>
        <div>
          <div>교대반</div>
          <div class="grid items-center gap-2" style="grid-template-columns: 1fr auto"><number-input class="mr-2" v-model="form.동일직무인원.교대반" :readonly="board.readonly || isRevision" />명</div>
        </div>
      </div>
    </maot-section>

    <!-- 위험성평가표 -->
    <div v-if="isRevision">
      <!-- 개정 중일 경우 -->
      <maot-section v-if="isDKRAS">
        <template #title>
          위험성평가표
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="DKRASTableData" :value="form.위험성평가표.data" :isRevision="true" :isDKRAS="true" :risk="form.위험성평가표.위험도" :important-risk="form.위험성평가표.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            :board="board"
            :controls="!(board.readonly || isRevision)"
            :is-print="isPrint"
            :tableData="DKRASTableData"
            :mobile="['분류', '원인', '발생빈도', '위험강도', '단위위험', '담당자', '완료예정일']"
            v-model="form.위험성평가표.data"
          >
            <template #customTitle>
              <div>
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div class="print-input">{{ form.위험성평가표.중요위험 }}</div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck, mobile, readonly }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th v-if="!(board.readonly || isRevision)" style="padding: 6px">
                    <div class="p-1 flex justify-center items-center">
                      <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                    </div>
                  </th>
                  <th>분류</th>
                  <th>원인</th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <th>담당자</th>
                  <th>완료일(예정일)</th>
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1"><vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox></th>
                  <th rowspan="2">분류</th>
                  <th rowspan="2">원인</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재조치 관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="1" colspan="3">개선후 위험도</th>
                  <th rowspan="2">개선결과</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ row, id, index }">
              <div v-if="id === '분류'" class="">
                <risk-fact-selector v-model="form.위험성평가표.data[index].분류" :readonly="board.readonly || isRevision" />
              </div>
              <div v-else-if="id === '원인'" class="">
                <risk-fact-selector v-model="form.위험성평가표.data[index].원인" :readonly="board.readonly || isRevision" :분류="form.위험성평가표.data[index].분류 || ' '" />
              </div>
              <div v-else-if="id === '단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.data[index].발생빈도, form.위험성평가표.data[index].위험강도).color }">
                  {{ form.위험성평가표.data[index].단위위험 }}({{ form.위험성평가표.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
              <div v-else-if="id === '개선후_단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.data[index].개선후_발생빈도, form.위험성평가표.data[index].개선후_위험강도).color }">
                  {{ form.위험성평가표.data[index].개선후_단위위험 }}({{ form.위험성평가표.data[index].개선후_위험도 }})
                </div>
                <div v-if="form.위험성평가표.data[index].개선후_위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>

        <div class="col-span-12 writeGridContainer mt-2 row-gap-2">
          <div class="writeGridLineItem">
            <div>안전보호구</div>
            <div><ml-input v-model="form.위험성평가표.안전보호구" :readonly="board.readonly || isRevision" /></div>
          </div>
          <div class="writeGridLineItem">
            <div>정리정돈사항</div>
            <div><ml-input v-model="form.위험성평가표.정리정돈사항" :readonly="board.readonly || isRevision" /></div>
          </div>
          <div class="writeGridLineItem">
            <div>ONE POINT</div>
            <div><ml-input v-model="form.위험성평가표.ONEPOINT" :readonly="board.readonly || isRevision" /></div>
          </div>
        </div>
      </maot-section>
      <maot-section v-if="isJSA">
        <template #title>
          위험성평가표
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="JSATableData" :value="form.위험성평가표.data" :isRevision="true" :isDKRAS="false" :risk="form.위험성평가표.위험도" :important-risk="form.위험성평가표.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            useRowGroup
            :board="board"
            :controls="false"
            :is-print="isPrint"
            :tableData="JSATableData"
            :mobile="['작업단계', '발생빈도', '위험강도', '단위위험', '개선대책']"
            :rowGroup="['작업단계', '작업사진', '검토1차', '검토2차', '비고']"
            v-model="form.위험성평가표.data"
          >
            <template #customTitle>
              <div class="writeGridContainer" style="width: 66.66%">
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.중요위험 }}</div>
                  </div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck, mobile }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th>작업단계</th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <th>개선대책</th>
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th rowspan="2">작업단계</th>
                  <th rowspan="2">작업사진</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                  <th rowspan="2">비고</th>
                  <th rowspan="1" colspan="3">개선후 위험도</th>
                  <th rowspan="2">개선결과</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ row, id, index }">
              <div v-if="id === '단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.data[index].발생빈도, form.위험성평가표.data[index].위험강도).color }">
                  {{ form.위험성평가표.data[index].단위위험 }}({{ form.위험성평가표.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
              <div v-else-if="id === '개선후_단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.data[index].개선후_발생빈도, form.위험성평가표.data[index].개선후_위험강도).color }">
                  {{ form.위험성평가표.data[index].개선후_단위위험 }}({{ form.위험성평가표.data[index].개선후_위험도 }})
                </div>
                <div v-if="form.위험성평가표.data[index].개선후_위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>
      </maot-section>
    </div>

    <div v-else>
      <maot-section v-if="isDKRAS">
        <template #title>
          위험성평가표
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="DKRASTableData" :value="form.위험성평가표.data" :isRevision="false" :isDKRAS="true" :risk="form.위험성평가표.위험도" :important-risk="form.위험성평가표.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            :board="board"
            :controls="!(board.readonly || isRevision)"
            :is-print="isPrint"
            :tableData="DKRASTableData"
            :mobile="['발생빈도', '위험강도', '단위위험']"
            :default-size="5"
            v-model="form.위험성평가표.data"
          >
            <template #customTitle>
              <div class="writeGridContainer" style="width: 66.66%">
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div class="print-input">{{ form.위험성평가표.중요위험 }}</div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck, mobile, readonly }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th v-if="!(board.readonly || isRevision)" style="padding: 6px">
                    <div class="p-1 flex justify-center items-center">
                      <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                    </div>
                  </th>
                  <th>분류</th>
                  <th>원인</th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <th>담당자</th>
                  <th>완료일(예정일)</th>
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1"><vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox></th>
                  <th rowspan="2">분류</th>
                  <th rowspan="2">원인</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재조치 관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ row, id, index }">
              <div v-if="id === '분류'" class="">
                <risk-fact-selector v-model="form.위험성평가표.data[index].분류" />
              </div>
              <div v-else-if="id === '원인'" class="">
                <risk-fact-selector v-model="form.위험성평가표.data[index].원인" :분류="form.위험성평가표.data[index].분류 || ' '" />
              </div>
              <div v-else-if="id === '단위위험'" class="">
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.data[index].발생빈도, form.위험성평가표.data[index].위험강도).color }">
                  {{ form.위험성평가표.data[index].단위위험 }}({{ form.위험성평가표.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>
        <div class="col-span-12 writeGridContainer mt-2 row-gap-2">
          <div class="writeGridLineItem">
            <div>안전보호구</div>
            <div><ml-input v-model="form.위험성평가표.안전보호구" /></div>
          </div>
          <div class="writeGridLineItem">
            <div>정리정돈사항</div>
            <div><ml-input v-model="form.위험성평가표.정리정돈사항" /></div>
          </div>
          <div class="writeGridLineItem">
            <div>ONE POINT</div>
            <div><ml-input v-model="form.위험성평가표.ONEPOINT" /></div>
          </div>
        </div>
      </maot-section>
      <maot-section v-if="isJSA">
        <template #title>
          위험성평가표
          <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
        </template>
        <div class="col-span-12">
          <print-table v-if="isPrint" :tableData="JSATableData" :value="form.위험성평가표.data" :isRevision="false" :isDKRAS="false" :risk="form.위험성평가표.위험도" :important-risk="form.위험성평가표.중요위험" />
          <table-custom
            v-else
            class="table-custom"
            border-x
            customThead
            useRowGroup
            :board="board"
            :controls="!(board.readonly || isRevision)"
            :is-print="isPrint"
            :tableData="JSATableData"
            :mobile="['작업단계', '발생빈도', '위험강도', '단위위험', '개선대책']"
            :rowGroup="['작업단계', '작업사진', '검토1차', '검토2차', '비고']"
            :default-size="5"
            v-model="form.위험성평가표.data"
          >
            <template #customTitle>
              <div class="writeGridContainer" style="width: 66.66%">
                <div class="col-span-6">
                  <div>위험도</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.위험도 }}</div>
                  </div>
                </div>
                <div class="col-span-6">
                  <div>중요위험</div>
                  <div>
                    <div class="print-input">{{ form.위험성평가표.중요위험 }}</div>
                  </div>
                </div>
              </div>
            </template>
            <template #customHead="{ allCheckValue, onClickAllCheck }">
              <fragment v-if="$viewport.isMobile">
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1"></th>
                  <th v-if="!(board.readonly || isRevision)" style="padding: 6px">
                    <div class="p-1 flex justify-center items-center">
                      <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                    </div>
                  </th>
                  <th>작업단계</th>
                  <th>발생빈도</th>
                  <th>위험강도</th>
                  <th>단위위험</th>
                  <th>개선대책</th>
                  <th></th>
                </tr>
              </fragment>
              <fragment v-else>
                <tr>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1"></th>
                  <th v-if="!(board.readonly || isRevision)" rowspan="2" class="p-1"><vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox></th>
                  <th rowspan="2">작업단계</th>
                  <th rowspan="2">작업사진</th>
                  <th rowspan="2">위험요인</th>
                  <th rowspan="2">현재관리상태</th>
                  <th rowspan="1" colspan="3">현재 위험도</th>
                  <th rowspan="2">감소대책</th>
                  <th rowspan="2">담당자</th>
                  <th rowspan="2">완료일(예정일)</th>
                  <th rowspan="1" colspan="2">적합성검토</th>
                  <th rowspan="2">비고</th>
                </tr>
                <tr>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>1차</th>
                  <th>2차</th>
                </tr>
              </fragment>
            </template>
            <template #customType="{ index }">
              <div>
                <div class="print-input" :style="{ color: getRisk(form.위험성평가표.data[index].발생빈도, form.위험성평가표.data[index].위험강도).color }">
                  {{ form.위험성평가표.data[index].단위위험 }}({{ form.위험성평가표.data[index].위험도 }})
                </div>
                <div v-if="form.위험성평가표.data[index].위험도 >= 20" style="color: #ea5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              </div>
            </template>
          </table-custom>
        </div>
      </maot-section>
    </div>

    <add-row-layout
      v-if="isJSA"
      title="개선내역"
      v-model="form.개선내역"
      :dataForm="{
        위험성평가: { 작업내용: '', 위험요인: '', 개선대책: '', 개선완료일: '' },
        개선사항: {
          개선전: { img: undefined, 설명: '', 빈도: '', 강도: '', 위험도: '' },
          개선후: { img: undefined, 설명: '', 빈도: '', 강도: '', 위험도: '' },
        },
      }"
    >
      <template #buttons="{ addRow, deleteRow }">
        <div v-if="!(board.readonly || isRevision)">
          <vs-button color="secondary" @click="addRow"> 개선내역 추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제 </vs-button>
        </div>
        <div v-else></div>
        <!-- isRevision 으로 template 속 div 를 모두 숨길경우, default 버튼이 나오므로, 그것을 방지하기 위해 빈 div 사용 -->
      </template>
      <template #default="{ data, index, checked, onCheck }">
        <p class="mb-2">- 개선내역 {{ index + 1 }}</p>
        <table class="mb-4">
          <tr>
            <th v-if="!(board.readonly || isRevision)" rowspan="6" class="cursor-pointer" @click="onCheck(index)"><vs-checkbox class="custom-checkbox justify-center mx-0" :checked="checked"></vs-checkbox></th>
            <th rowspan="2">위험성평가</th>
            <th rowspan="1">작업내용</th>
            <th rowspan="1">위험요인</th>
            <th rowspan="1">개선대책</th>
            <th rowspan="1">개선완료일</th>
          </tr>
          <tr>
            <td><ml-input :readonly="board.readonly || isRevision" v-model="form.개선내역[index].위험성평가.작업내용" /></td>
            <td><ml-input :readonly="board.readonly || isRevision" v-model="form.개선내역[index].위험성평가.위험요인" /></td>
            <td><ml-input :readonly="board.readonly || isRevision" v-model="form.개선내역[index].위험성평가.개선대책" /></td>
            <td><date-selector :readonly="board.readonly || isRevision" class="w-full" v-model="form.개선내역[index].위험성평가.개선완료일" /></td>
          </tr>
          <tr>
            <th rowspan="4" colspan="1">개선사항</th>
            <th rowspan="1" colspan="2">개선 전</th>
            <th rowspan="1" colspan="2">개선 후</th>
          </tr>
          <tr>
            <td colspan="2"><FileUploaderTransparent2 :readonly="board.readonly || isRevision" v-model="form.개선내역[index].개선사항.개선전.img" style="height: 200px !important; border: 1px dashed #cdcdcd; border-radius: 6px" /></td>
            <td colspan="2"><FileUploaderTransparent2 :readonly="board.readonly || isRevision" v-model="form.개선내역[index].개선사항.개선후.img" style="height: 200px !important; border: 1px dashed #cdcdcd; border-radius: 6px" /></td>
          </tr>
          <tr>
            <td colspan="2" v-for="개선전후 in ['개선전', '개선후']">
              <table>
                <colgroup>
                  <col />
                  <col width="83px" />
                  <col width="83px" />
                  <col width="114px" />
                </colgroup>
                <tr>
                  <td rowspan="2">
                    <ml-textarea :readonly="board.readonly || isRevision" v-model="form.개선내역[index].개선사항[개선전후].설명" />
                  </td>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>빈도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>강도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                  <th>
                    <div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>위험도</span>
                      <feather-icon style="width: 20px; color: #7e72f2" icon="AlertCircleIcon" />
                    </div>
                  </th>
                </tr>
                <tr>
                  <td>
                    <vs-select :disabled="board.readonly || isRevision" class="w-full" v-model="form.개선내역[index].개선사항[개선전후].빈도">
                      <vs-select-item v-for="item in ['5', '4', '3', '2', '1']" :key="item" :value="item" :text="item" />
                    </vs-select>
                  </td>
                  <td>
                    <vs-select :disabled="board.readonly || isRevision" class="w-full" v-model="form.개선내역[index].개선사항[개선전후].강도">
                      <vs-select-item v-for="item in ['4', '3', '2', '1']" :key="item" :value="item" :text="item" />
                    </vs-select>
                  </td>
                  <td>
                    <div class="print-input" :style="{ color: getRisk(form.개선내역[index].개선사항[개선전후].빈도, form.개선내역[index].개선사항[개선전후].강도).color }">
                      {{ getRisk(form.개선내역[index].개선사항[개선전후].빈도, form.개선내역[index].개선사항[개선전후].강도).name }}({{ form.개선내역[index].개선사항[개선전후].위험도 || 0 }})
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </template>
    </add-row-layout>

    <!-- 파일첨부 -->
    <file-upload-module v-model="form.fileList" :is-print="isPrint" class="mt-8" />

    <popup-risk-dksteel-frequency v-model="popup.빈도" />
    <popup-risk-dksteel-strength v-model="popup.강도" />
    <popup-risk-dksteel-decision v-model="popup.위험도" />
    <vs-popup :active.sync="popup.warning20" title="알림">
      <div>
        <table>
          <tr>
            <th style="color: #e42728">
              <div class="flex items-center justify-center">
                <feather-icon class="mr-2" icon="AlertCircleIcon" />
                <span>평가결과 20점 이상</span>
              </div>
            </th>
          </tr>
          <tr>
            <td>
              <div>※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              <div>※ 담당임원에게 결재 바랍니다.</div>
            </td>
          </tr>
        </table>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import MaotSection from "@/components/layout/MaotSection.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import Select736Button from "@/views/boards/single-page/736/Select736Button.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import NumberInput from "@/components/NumberInput.vue";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import AddRowLayout from "@/components/layout/AddRowLayout.vue";
import FileUploader from "@/components/FileUploader.vue";
import FileUploaderTransparent2 from "@/components/FileUploaderTransparent2.vue";
import PopupRiskInfoEp1 from "@/views/project/popup/PopupRiskInfoEp1.vue";
import PopupRiskInfoEp2 from "@/views/project/popup/PopupRiskInfoEp2.vue";
import PopupRiskInfoEp3 from "@/views/project/popup/PopupRiskInfoEp3.vue";
import 유해위험요인 from "@/components/selector/riskFactor/유해위험요인.js";
import RiskFactSelector from "@/components/selector/riskFactor/RiskFactSelector.vue";
import { required } from "vuelidate/lib/validators";
import PopupRiskDksteelFrequency from "@/views/project/popup/PopupRiskDksteelFrequency.vue";
import PopupRiskDksteelStrength from "@/views/project/popup/PopupRiskDksteelStrength.vue";
import PopupRiskDksteelDecision from "@/views/project/popup/PopupRiskDksteelDecision.vue";
import PrintTable from "@/views/boards/single-page/813/PrintTable.vue";

export default {
  components: {
    PrintTable,
    PopupRiskDksteelDecision,
    PopupRiskDksteelStrength,
    PopupRiskDksteelFrequency,
    RiskFactSelector,
    PopupRiskInfoEp3,
    PopupRiskInfoEp2,
    PopupRiskInfoEp1,
    FileUploaderTransparent2,
    FileUploader,
    AddRowLayout,
    NameWithSignatureRow,
    SignField,
    NumberInput,
    TableCustom,
    CustomOptionSelector,
    Select736Button,
    DateSelector,
    RadioGroup,
    MaotSection,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    parentId: [Number, String],
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
      위험성평가정보: {
        평가일자: { required },
      },
    },
  },
  data() {
    return {
      유해위험요인,
      popup: {
        빈도: false,
        강도: false,
        위험도: false,
        warning20: false,
      },
      DKRASTableData: [
        { id: "분류", title: "분류", type: "customType", width: "163px" },
        { id: "원인", title: "원인", type: "customType", width: "163px" },
        { id: "위험요인", title: "위험요인", type: "textarea", width: "163px" },
        { id: "현재조치관리상태", title: "현재조치 관리상태", type: "textarea", width: "163px" },
        { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "단위위험", title: "단위위험", type: "customType", width: "114px" },
        { id: "감소대책", title: "감소대책", type: "textarea", width: "163px" },
        { id: "담당자", title: "담당자", type: "text", width: "163px" },
        { id: "완료예정일", title: "완료예정일", type: "date", width: "163px" },
        { id: "검토1차", title: "1차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", defaultValue: "Y" },
        { id: "검토2차", title: "2차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", defaultValue: "Y" },
      ],
      JSATableData: [
        { id: "작업단계", title: "작업단계", type: "textarea", width: "197px" },
        { id: "작업사진", title: "작업사진", type: "img", width: "197px" },
        { id: "위험요인", title: "위험요인", type: "textarea", width: "197px" },
        { id: "현재관리상태", title: "현재관리상태", type: "textarea", width: "197px" },
        { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
        { id: "단위위험", title: "단위위험", type: "customType", width: "83px" },
        { id: "감소대책", title: "감소대책", type: "textarea", width: "197px" },
        { id: "비고", title: "비고", type: "textarea", width: "197px" },
      ],

      form: {
        // 산업재해 발생현황(823) 글 ID — 본문에 저장되는 연결 키.
        // form 안에 있어야 수정 모드에서 저장된 값이 복원되고, 재저장 시에도 유지된다.
        connect823Id: null,
        stdInfo: {},
        fileList: [],
        위험성평가구분: "",
        위험성평가정보: {
          평가일자: "",
          공장: "",
          팀: "",
          공정: "",
        },
        공정분류: {
          대분류: "",
          중분류: "",
          소분류: "",
          구분: "",
          구분_수시: "",
          구분_수시_기타: "",
          아차사고: "",
          raw: undefined,
        },
        아차사고: [],
        아차사고_개정: [{ id: 1, 재해발생유형_분류: "", 재해발생유형_원인: "", 원인: "", 내용: "" }],
        작업빈도: {
          일: "",
          주: "",
          월: "",
          분기: "",
          년: "",
          회당작업시간: "",
        },
        sign: {
          작성자: { name: "", sign: "" },
          검토자: { name: "", sign: "" },
        },
        동일직무인원: {
          상주반: "",
          교대반: "",
        },
        위험성평가표: {
          위험도: "",
          중요위험: "",
          data: [],
          안전보호구: "",
          정리정돈사항: "",
          ONEPOINT: "",
        },
        개선내역: [
          {
            위험성평가: { 작업내용: "", 위험요인: "", 개선대책: "", 개선완료일: "" },
            개선사항: {
              개선전: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
              개선후: { img: undefined, 설명: "", 빈도: "", 강도: "", 위험도: "" },
            },
          },
        ],
      },
      is위험도20: false,

      isLoad945: false,
      // 같은 823 에 연결된 945(개선후) 글 ID — 저장되지 않는 조회용 값. 열 때마다 connect823Id 로 서버에서 찾아 "위험성평가(개선후)" 버튼 이동에만 쓴다.
      connect945Id: null,
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    isDKRAS() {
      return this.form.위험성평가구분 === "DKRAS";
    },
    isJSA() {
      return this.form.위험성평가구분 === "JSA";
    },
    isRevision() {
      return this.parentId > 0;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    isRevision(value) {
      this.watchRevision();
    },
    "form.위험성평가표.data": {
      deep: true,
      handler(list) {
        if (list && list.length > 0) {
          let sum위험도 = 0;
          let is중요위험 = false;
          this.is위험도20 = false;
          list = list.map((item, index) => {
            // 현재 위험도
            const 발생빈도 = Number(item.발생빈도 || 0);
            const 위험강도 = Number(item.위험강도 || 0);
            const 위험도 = 발생빈도 * 위험강도;
            sum위험도 += 위험도;
            if (발생빈도 >= 5 || 위험도 >= 10) {
              is중요위험 = true;
            }

            item.위험도 = 위험도;
            item.단위위험 = this.getRisk(발생빈도, 위험강도).name;

            if (위험도 >= 20) {
              this.is위험도20 = true;
            }

            // 개선후 위험도
            if (this.isRevision) {
              const 개선후_발생빈도 = Number(item.개선후_발생빈도 || 0);
              const 개선후_위험강도 = Number(item.개선후_위험강도 || 0);
              const 개선후_위험도 = 개선후_발생빈도 * 개선후_위험강도;
              item.개선후_위험도 = 개선후_위험도;
              item.개선후_단위위험 = this.getRisk(개선후_발생빈도, 개선후_위험강도).name;
            }

            return item;
          });
          this.form.위험성평가표.위험도 = (sum위험도 / list.length).toFixed(1);
          this.form.위험성평가표.중요위험 = is중요위험 ? "Y" : "N";
        }
      },
    },
    "form.개선내역": {
      deep: true,
      handler(list) {
        if (list && list.length > 0) {
          list = list.map((item, index) => {
            for (const 개선전후 of ["개선전", "개선후"]) {
              const 위험도 = Number(item.개선사항[개선전후].빈도 || 0) * Number(item.개선사항[개선전후].강도 || 0);
              item.개선사항[개선전후].위험도 = 위험도;
            }
            return item;
          });
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);

        if (value.connect823Id && !this.isLoad945) this.load945();
      },
    },
  },
  async created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    this.watchRevision();

    // ====================================================================

    // 생성페이지일때
    if (!this.board.readonly && !this.postId) {
      const connect823 = this.$store.state.board.boardConnect823;
      // 생성페이지인데 823ID가 없으면 뒤로가기기
      if (!connect823) {
        this.$router.back();
        return;
      }
      if (!this.form.connect823Id) this.form.connect823Id = connect823;
    }
  },
  mounted() {
    // 버튼 위치 변경경
    const rightButtonContainer = document.getElementById("right-button-container");
    const newBtn = this.$refs.newBtn;

    if (rightButtonContainer && newBtn) {
      // newBtn의 자식 노드를 배열로 가져오기
      const children = Array.from(newBtn.childNodes);

      // 역순으로 삽입
      for (let i = children.length - 1; i >= 0; i--) {
        rightButtonContainer.insertBefore(children[i], rightButtonContainer.firstChild);
      }

      // 기존 ref 요소 제거
      newBtn.remove();
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
        if (!this.$v.form.위험성평가정보.평가일자.required) return "위험성평가 정보의 평가일자를 반드시 입력해야 합니다";
      }
    },

    //  ===== 업데이트 페이지일때 연결된 945 postId를 찾는다. ========
    async load945() {
      this.isLoad945 = true;
      if (this.postId) {
        // 945 호출
        const res945 = await this.$store.dispatch("approval/LOAD_POST_ALL", {
          projectId: this.projectId,
          boardSlug: `board-945`,
          page: 1,
          perPage: 1,
          orderTarget: "created_at",
          orderDirection: "desc",
          conditions: [{ key: "body.connect823Id", operator: "=", value: `${this.form.connect823Id}` }],
        });

        const post945 = res945 && res945.data && res945.data.length > 0 ? res945.data[0] : null;
        if (post945) this.connect945Id = post945.post_id;
      }
    },

    /**
     * 산업재해 발생현황, 개선후 게시글 생성 페이지로 이동
     * 만약 작성된 페이지가 존재하면 작성된 페이지로 이동
     * 0: 산업재해 발생현황, 1: 개선후
     */
    movePage(type) {
      // 페이지 이동
      switch (type) {
        case 0:
          this.$router.push({
            name: "write|update|tab",
            params: {
              boardId: "823",
              boardSlug: "board-823",
              pageType: "write",
              proj_id: this.projectId,
              postId: this.form.connect823Id,
            },
          });
          break;
        case 1:
          if (this.connect945Id) {
            this.$router.push({
              name: "write|update|tab",
              params: {
                boardId: "945",
                boardSlug: "board-945",
                pageType: "write",
                proj_id: this.projectId,
                postId: this.connect945Id,
              },
            });
          } else {
            this.$store.commit("board/SET_BOARD_CONNECT_823", this.form.connect823Id);
            this.$router.push({
              name: "write|tab",
              params: {
                boardId: "945",
                boardSlug: "board-945",
                pageType: "write",
                proj_id: this.projectId,
              },
            });
          }
          break;
      }
    },

    watchRevision() {
      // 개정할 경우, DKRAS, JSA 테이블 데이터를 변경
      if (this.isRevision) {
        this.DKRASTableData = [
          { id: "분류", title: "분류", type: "customType", width: "163px", readonly: true },
          { id: "원인", title: "원인", type: "customType", width: "163px", readonly: true },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "163px", readonly: true },
          { id: "현재조치관리상태", title: "현재조치 관리상태", type: "textarea", width: "163px", readonly: true },
          { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", readonly: true },
          { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", readonly: true },
          { id: "단위위험", title: "단위위험", type: "customType", width: "114px", readonly: true },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "163px", readonly: true },

          { id: "개선후_발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "개선후_위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "개선후_단위위험", title: "단위위험", type: "customType", width: "114px" },
          { id: "개선결과", title: "개선결과", type: "textarea", width: "163px" },

          { id: "담당자", title: "담당자", type: "text", width: "163px", readonly: true },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px", readonly: true },
          { id: "검토1차", title: "1차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", readonly: true, defaultValue: "Y" },
          { id: "검토2차", title: "2차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", readonly: true, defaultValue: "Y" },
        ];
        this.JSATableData = [
          { id: "작업단계", title: "작업단계", type: "textarea", width: "197px", readonly: true },
          { id: "작업사진", title: "작업사진", type: "img", width: "197px", readonly: true },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "197px", readonly: true },
          { id: "현재관리상태", title: "현재관리상태", type: "textarea", width: "197px", readonly: true },
          { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", readonly: true },
          { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px", readonly: true },
          { id: "단위위험", title: "단위위험", type: "customType", width: "83px", readonly: true },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "197px", readonly: true },

          { id: "담당자", title: "담당자", type: "text", width: "163px", readonly: true },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px", readonly: true },
          { id: "검토1차", title: "1차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", readonly: true, defaultValue: "Y" },
          { id: "검토2차", title: "2차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", readonly: true, defaultValue: "Y" },
          { id: "비고", title: "비고", type: "textarea", width: "197px", readonly: true },

          { id: "개선후_발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "개선후_위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "개선후_단위위험", title: "단위위험", type: "customType", width: "83px" },
          { id: "개선결과", title: "개선결과", type: "textarea", width: "197px" },
        ];
      } else {
        this.DKRASTableData = [
          { id: "분류", title: "분류", type: "customType", width: "163px" },
          { id: "원인", title: "원인", type: "customType", width: "163px" },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "163px" },
          { id: "현재조치관리상태", title: "현재조치 관리상태", type: "textarea", width: "163px" },
          { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "단위위험", title: "단위위험", type: "customType", width: "114px" },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "163px" },
          { id: "담당자", title: "담당자", type: "text", width: "163px" },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px" },
          { id: "검토1차", title: "1차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", defaultValue: "Y" },
          { id: "검토2차", title: "2차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", defaultValue: "Y" },
        ];
        this.JSATableData = [
          { id: "작업단계", title: "작업단계", type: "textarea", width: "197px" },
          { id: "작업사진", title: "작업사진", type: "img", width: "197px" },
          { id: "위험요인", title: "위험요인", type: "textarea", width: "197px" },
          { id: "현재관리상태", title: "현재관리상태", type: "textarea", width: "197px" },
          { id: "발생빈도", title: "발생빈도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "위험강도", title: "위험강도", type: "select", selectData: ["5", "4", "3", "2", "1"], width: "83px" },
          { id: "단위위험", title: "단위위험", type: "customType", width: "83px" },
          { id: "감소대책", title: "감소대책", type: "textarea", width: "197px" },
          { id: "담당자", title: "담당자", type: "text", width: "163px" },
          { id: "완료예정일", title: "완료예정일", type: "date", width: "163px" },
          { id: "검토1차", title: "1차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", defaultValue: "Y" },
          { id: "검토2차", title: "2차", type: "radio", radioItems: [{ value: "Y" }, { value: "N" }], width: "90px", defaultValue: "Y" },
          { id: "비고", title: "비고", type: "textarea", width: "197px" },
        ];
      }
    },

    // 문서 우측 상단 버튼들
    // 커스텀 버튼을 넣고 싶은 경우, tab/Index.vue 의 writeApprovalButtonsTemplate 함수를 참고하여 Json 작성
    setApprovalButtons(template) {
      const 개정 = JSON.parse(JSON.stringify(template.resend));
      개정.content = "개정";
      개정.shouldShow.custom = ["approved"].indexOf(this.board.statusCode) > -1; // 승인된 경우에만 개정 가능
      개정.emits.click = (func) => {
        this.form.위험성평가정보.평가일자 = new Date().format("yyyy-MM-dd");
        func.resend("개정 할 경우\n기존 문서는 유지되고, 내용이 복사되어 임시저장 됩니다.\n개정 하시겠습니까?");
      };

      const saveFunc = template.save.emits.click;
      template.save.emits.click = (func) => {
        if (this.is위험도20) {
          this.popup.warning20 = true;
        } else {
          saveFunc(func);
        }
      };
      return [개정, template.resend, template.print, template.delete, template.move, template.save];
    },
    resetForm(key) {
      if (key === "위험성평가표") {
        this.form[key].위험도 = "";
        this.form[key].중요위험 = "";
        this.form[key].안전보호구 = "";
        this.form[key].정리정돈사항 = "";
        this.form[key].ONEPOINT = "";

        this.form[key].data = [];
        const len = this.form[key].data.length;
        for (let i = 0; i < len - 1; i++) {
          this.form[key].data.pop();
        }

        if (this.form[key].data.length > 0) {
          if (this.isDKRAS) {
            this.form[key].data[0].분류 = "";
            this.form[key].data[0].원인 = "";
            this.form[key].data[0].위험요인 = "";
            this.form[key].data[0].현재조치관리상태 = "";
            this.form[key].data[0].발생빈도 = "1";
            this.form[key].data[0].위험강도 = "1";
            this.form[key].data[0].단위위험 = "1";
            this.form[key].data[0].감소대책 = "";
            this.form[key].data[0].담당자 = "";
            this.form[key].data[0].완료예정일 = "";
            this.form[key].data[0]["1차"] = "";
            this.form[key].data[0]["2차"] = "";
          } else if (this.isJSA) {
            this.form[key].data[0].작업단계 = "";
            this.form[key].data[0].작업사진 = undefined;
            this.form[key].data[0].위험요인 = "";
            this.form[key].data[0].발생빈도 = "1";
            this.form[key].data[0].위험강도 = "1";
            this.form[key].data[0].단위위험 = "1";
            this.form[key].data[0].감소대책 = "";
            this.form[key].data[0].비고 = "";
          }
        }
      }
    },
    getRisk(발생빈도, 위험강도) {
      const 위험도 = parseInt(발생빈도) * parseInt(위험강도);

      if (위험도 >= 20) {
        return {
          name: "중요위험(허용불가능)",
          color: "#EA5455",
        };
      }

      if (위험도 >= 10 || 발생빈도 >= 5) {
        return {
          name: "중요위험(허용가능)",
          color: "#FF9F43",
        };
      }

      return {
        name: "일반",
        color: "#28C76F",
      };
    },
    onSelectProcess(raw) {
      this.form.공정분류.대분류 = raw.대분류;
      this.form.공정분류.중분류 = raw.중분류;
      this.form.공정분류.소분류 = raw.소분류;
      this.form.위험성평가정보.공장 = raw.공장명;
      this.form.위험성평가정보.팀 = raw.팀명;
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 0.5rem;
    text-align: center;
  }
  th {
    background-color: #f9f9f9;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    font-weight: bold;
    color: #3c3c3c;
  }
  td {
    background-color: #fff;
  }
}
.table-custom ::v-deep {
  .table-custom-body {
    overflow-x: auto;
  }
}
.custom-btn {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
